export const articles = [
  {
    id: "ent-001",
    title: "剧组临时改档期，工作人员是怎么连夜重排通告的",
    summary:
      "一次外景临时调整，背后是几十个人、上百条通告的连锁反应。我们跟着一位现场统筹，看他把混乱重新排回秩序。",
    category: "entertainment",
    categoryName: "娱乐圈瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20film%20clapperboard%20with%20abstract%20scheduling%20grid%20and%20spotlight%20shapes%2C%20warm%20coral%20and%20cream%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-01&orientation=landscape",
    author: "瓜田观察员",
    authorRole: "前方记录",
    date: "2026-09-12",
    readTime: "6 分钟",
    views: 28450,
    likes: 1732,
    tags: ["剧组日常", "现场统筹", "流程科普"],
    hot: true,
    featured: true,
    points: [
      "外景档期一变，灯光、场地、车辆、演员几条线要同时重排",
      "通告单不是越细越好，留出缓冲段反而更抗意外",
      "真正专业的统筹，是先保住最贵、最难约的那一环",
    ],
    content: [
      { type: "p", text: "晚上十点，群里跳出一条消息：明天下午的日戏外景因为场地原因要整体往后推半天。看起来只是「换个时间」，但现场统筹阿哲的手机在接下来四小时里几乎没停过。" },
      { type: "h2", text: "一条通告改动，牵动的是五条线" },
      { type: "p", text: "阿哲把要重排的东西分成五类：演员档期、场地与备案、灯光与器材租赁、车辆与群演、以及后期需要的素材完整度。他说，新手最容易只盯着演员，觉得人到了就能拍，结果灯光车没到、群演没通知，全组在片场干等。" },
      { type: "p", text: "重排的顺序也有讲究。他先锁死最难约的那一环——那位只给了两天档期的客串演员；再确认外景地第二天是否还允许拍摄；最后才是把室内戏提前填进空出来的上午。" },
      { type: "quote", text: "「通告单不是把每一分钟填满，而是把最贵的资源放在最稳的位置。」" },
      { type: "h2", text: "为什么专业通告单总会留一段空" },
      { type: "p", text: "我看过一份被夸「专业」的新通告单，上午被拆成了两个景别加一段机动时间。阿哲解释，那段机动时间是故意留的：天光、设备、演员状态都可能波动，有缓冲才能不慌。填得太满的通告单，往往第一次意外就崩了。" },
      { type: "h2", text: "改完之后，先通知谁" },
      { type: "p", text: "新通告发出去的顺序，是先私聊关键演员确认，再在群里统一公告，最后逐个电话确认不会看手机的场务和司机。阿哲说，公告是效率，电话是保险，两个都要有。" },
      { type: "p", text: "凌晨两点，新的通告单终于定稿。第二天下午的戏顺利补拍，几乎没有浪费时间。这件事在外人眼里只是「改了个时间」，但对现场来说，是一次体力和判断力的双重考验。" },
    ],
  },
  {
    id: "ent-002",
    title: "综艺现场观众的手机是怎么被收走的？一次录制的完整流程",
    summary:
      "从排队入场到散场归还，观众的手机在录制期间经历了什么。了解流程之后，你会发现这背后全是保密与体验的平衡。",
    category: "entertainment",
    categoryName: "娱乐圈瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20studio%20stage%20lights%20and%20numbered%20seats%2C%20amber%20and%20olive%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-02&orientation=landscape",
    author: "深夜编辑部",
    authorRole: "流程拆解",
    date: "2026-09-11",
    readTime: "5 分钟",
    views: 21030,
    likes: 1204,
    tags: ["综艺录制", "现场流程", "观众体验"],
    hot: true,
    featured: false,
    points: [
      "手机通常在入场安检环节集中保管，而不是录制中途才收",
      "每个座位都有编号，方便散场后快速归还",
      "保密之外，收手机也是为了减少现场杂音和光污染",
    ],
    content: [
      { type: "p", text: "很多第一次去综艺现场的人都会问：手机到底什么时候被收？答案是，通常在你还没坐进演播厅之前。" },
      { type: "h2", text: "入场三关：验票、安检、存包" },
      { type: "p", text: "验票确认你是本人预约的观众；安检会过一遍随身物品，水和打火机一般不让带；最后是存包环节，手机、相机、录音笔会被装进带编号的收纳袋，和你的座位号一一对应。" },
      { type: "p", text: "工作人员解释，编号对应是为了散场效率。一场录制几百位观众，如果没有编号，归还手机就会变成一场混乱的寻找。" },
      { type: "quote", text: "「不是不信任观众，是几百台手机同时亮屏，现场根本录不下去。」" },
      { type: "h2", text: "为什么录制中途也需要安静" },
      { type: "p", text: "除了防止片段提前流出，手机还会带来两个实际麻烦：来电震动和屏幕反光。收音设备很敏感，一次震动可能让整条音轨作废。听懂这一点后，大多数观众都能理解为什么要统一保管。" },
      { type: "h2", text: "散场时的秩序感" },
      { type: "p", text: "散场不是一窝蜂。工作人员会按区域分批引导，第一排先走还是后排先走，取决于通道设计。拿到手机后，观众往往第一件事是拍照留念，这反而成了很多人对现场最后的记忆。" },
    ],
  },
  {
    id: "ent-003",
    title: "为什么演员读本要分三轮？剧组前期那些看不见的准备",
    summary:
      "正式开机前，剧本已经被人反复读过很多遍。三轮读本各自解决什么问题，决定了成片里台词的质感。",
    category: "entertainment",
    categoryName: "娱乐圈瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20open%20script%20pages%20with%20pencil%20marks%20and%20a%20reading%20lamp%2C%20cream%20and%20coral%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-03&orientation=landscape",
    author: "编剧小林",
    authorRole: "前期策划",
    date: "2026-09-09",
    readTime: "7 分钟",
    views: 15220,
    likes: 861,
    tags: ["读本会", "剧本", "剧组前期"],
    hot: false,
    featured: false,
    points: [
      "第一轮解决故事逻辑，第二轮解决人物关系，第三轮才抠台词",
      "读本不是为了背台词，而是让不同角色第一次在同一空间对话",
      "提前发现的问题，成本远低于开机后返工",
    ],
    content: [
      { type: "p", text: "很多人以为读本就是大家坐在一起把剧本念一遍。真到了剧组你会发现，同一份剧本要被读三轮，每一轮关注的东西都不一样。" },
      { type: "h2", text: "第一轮：故事先讲通" },
      { type: "p", text: "第一轮通常由编剧和导演主导，重点是「这个故事有没有漏洞」。谁的信息什么时候被谁知道、哪条线可以提前埋，这一轮会动结构，甚至整场戏重排。" },
      { type: "h2", text: "第二轮：让角色关系成立" },
      { type: "p", text: "第二轮演员开始在场。导演会让大家先不急着找情绪，而是先确认人物之间的关系：这句话是熟人说的还是陌生人说的，语气完全不同。很多现场「怪怪的」感觉，其实来自关系没对齐。" },
      { type: "quote", text: "「台词可以改，关系一旦错了，观众第一秒就会觉得假。」" },
      { type: "h2", text: "第三轮：抠字眼和节奏" },
      { type: "p", text: "到第三轮，讨论细到某个词要不要换、哪句该停半拍。演员会提出「这句我很难说出口」，编剧现场调整，往往比后期配音省事得多。" },
      { type: "p", text: "三轮读本加起来可能只花几天，却能避免开机后因为逻辑不通而整场重拍。对剧组来说，这是性价比极高的前期投入。" },
    ],
  },
  {
    id: "wok-001",
    title: "面试被追问离职原因，怎么回答既不撒谎也不吃亏",
    summary:
      "离职原因几乎是每场面试的必答题。重点不在于隐瞒什么，而在于把同一段经历讲成对方能放心的版本。",
    category: "workplace",
    categoryName: "职场瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20interview%20table%20with%20chair%20and%20folder%20shapes%2C%20olive%20green%20and%20cream%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-04&orientation=landscape",
    author: "老张的记录本",
    authorRole: "十年 HR",
    date: "2026-09-12",
    readTime: "6 分钟",
    views: 33110,
    likes: 2415,
    tags: ["面试", "离职原因", "沟通"],
    hot: true,
    featured: true,
    points: [
      "面试官真正想确认的是：你会不会因为同样的问题再次离开",
      "把抱怨改写成选择，把情绪改写成标准",
      "离职原因控制在三句话内，先给结论再给背景",
    ],
    content: [
      { type: "p", text: "「上一份工作为什么离职？」这句话几乎每次面试都会出现。很多人第一反应是紧张，怕说真话被扣分，说假话又会被追问穿。" },
      { type: "h2", text: "面试官到底在担心什么" },
      { type: "p", text: "作为面试官，我问这个问题，并不是想听你吐槽前公司。我真正想确认三件事：你的离职动机是否合理、你和新岗位的匹配度、以及你会不会因为同样的原因再次离开。" },
      { type: "h2", text: "把抱怨翻译成标准" },
      { type: "p", text: "「领导乱安排」可以翻译成「我希望工作优先级更清晰」；「公司没前景」可以翻译成「我希望加入业务在增长、职责边界更明确的团队」。同一件事，前者是情绪，后者是标准，而标准正好能和目标岗位对上。" },
      { type: "quote", text: "「不要试图证明前公司不好，要让对方觉得你想清楚了下一站在哪。」" },
      { type: "h2", text: "三句话结构最好用" },
      { type: "p", text: "我的建议是：第一句讲客观变化（组织调整、项目结束），第二句讲你的判断（我更适合什么方向），第三句讲你为此做了什么（所以我看了贵司的岗位）。三句话，有事实、有逻辑、有选择。" },
      { type: "p", text: "最后提醒一点：不要说前公司任何具体的人名和隐私。你不知道对面的圈子有多大，一句随口的抱怨，可能比一次失败的面试影响更久。" },
    ],
  },
  {
    id: "wok-002",
    title: "绩效面谈前一周，我提前把这三件事做完了",
    summary:
      "很多人绩效面谈是「被动挨打」，其实是可以在谈之前就把主动权拿回来的。三件准备工作，成本很低但很管用。",
    category: "workplace",
    categoryName: "职场瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20performance%20chart%20with%20checkmark%20notes%20and%20pen%20shapes%2C%20amber%20and%20olive%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-05&orientation=landscape",
    author: "打工人阿May",
    authorRole: "产品经理",
    date: "2026-09-10",
    readTime: "5 分钟",
    views: 19870,
    likes: 1420,
    tags: ["绩效", "向上沟通", "职场方法"],
    hot: false,
    featured: false,
    points: [
      "提前整理过去半年的关键产出，而不是等对方给你打分",
      "把「我做了什么」改写成「带来了什么变化」",
      "主动准备一两个想争取的方向，面谈不是汇报而是协商",
    ],
    content: [
      { type: "p", text: "绩效面谈最常见的错误，是空手赴约。你带着「希望被认可」的心情走进去，对方带着一份已经打好的分数。谈的过程，就成了接受结果的过程。" },
      { type: "h2", text: "第一件事：把产出重新组织成变化" },
      { type: "p", text: "我用的方法是「动作 + 结果 + 影响」。不要说「我负责了某项目的排期」，而要说「我把项目排期从三周压到两周，让上线提前了一周」。前者是任务，后者是价值。" },
      { type: "h2", text: "第二件事：准备好接受的批评" },
      { type: "p", text: "面谈里对方一定会提不足。提前想清楚哪些不足你认可、哪些需要补充背景。你不需要争输赢，但要让对方看到你不是在辩解，而是在理解。" },
      { type: "quote", text: "「绩效面谈不是考试，是一次低成本的期望对齐。」" },
      { type: "h2", text: "第三件事：带着诉求去" },
      { type: "p", text: "面谈的最后，我会主动提一到两个方向，比如下一阶段想主导哪块、希望获得什么支持。谈完如果不能立刻给结果，至少让这件事进入了对方的记录。" },
      { type: "p", text: "提前一周准备，面谈时你会发现自己从容很多。差距往往不在能力，而在有没有把能力讲清楚。" },
    ],
  },
  {
    id: "wok-003",
    title: "从大厂跳到二十人小团队，三个月后我最想说的话",
    summary:
      "决定跳槽时我以为只是换了公司，三个月后才发现换的是一整套工作方式。这里有三个真实但没人提前告诉我的落差。",
    category: "workplace",
    categoryName: "职场瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20small%20team%20desk%20with%20plants%20and%20whiteboard%20shapes%2C%20coral%20and%20cream%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-06&orientation=landscape",
    author: "阿哲不加班",
    authorRole: "前端工程师",
    date: "2026-09-08",
    readTime: "7 分钟",
    views: 24560,
    likes: 1789,
    tags: ["跳槽", "小团队", "职业选择"],
    hot: true,
    featured: false,
    points: [
      "流程变少了，但每个决定都要你自己负责",
      "小团队不是没有政治，只是换了更直接的形式",
      "成长速度变快，是因为没人替你兜底",
    ],
    content: [
      { type: "p", text: "离开大厂那天，我以为最难的会是适应新环境。三个月后我发现，真正难的是重新校准「什么叫做得好」。" },
      { type: "h2", text: "落差一：没有人替你定义优先级" },
      { type: "p", text: "在大厂，排期表和需求文档会告诉你今天做什么。小团队里，需求常常只是一句话：「这个功能你觉得急不急？」你得自己判断，而且判断错了要自己承担。" },
      { type: "h2", text: "落差二：沟通变短了，但更锋利" },
      { type: "p", text: "人少意味着信息传导快，也意味着没有缓冲。你的方案好不好，当天就能听到直接反馈，有时候甚至当面被否掉。习惯之后你会发现，这比大厂里绕三圈的会议高效得多。" },
      { type: "quote", text: "「小团队不是没有政治，只是把政治压缩成了一次次直接的对话。」" },
      { type: "h2", text: "落差三：成长是真的快，代价也真实" },
      { type: "p", text: "因为没人替你兜底，你必须从写代码延伸到上线、监控、甚至和客户解释。能力边界扩得很快，但节假日被叫起来处理问题也是常态。" },
      { type: "p", text: "如果让我给还在犹豫的人一句话：先想清楚你要的是稳定还是成长空间，然后接受它对应的代价。小团队没有更好或更坏，只有适不适合此刻的你。" },
    ],
  },
  {
    id: "cam-001",
    title: "选课冲突那天，我用一张表把四年课表排明白了",
    summary:
      "选课季最容易犯的错，是只顾着凑学分。一张包含先修关系和冲突段的表格，能让后面几个学期都轻松很多。",
    category: "campus",
    categoryName: "校园瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20timetable%20grid%20with%20clock%20and%20pencil%20shapes%2C%20amber%20and%20cream%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-07&orientation=landscape",
    author: "大四学姐小满",
    authorRole: "过来人",
    date: "2026-09-12",
    readTime: "6 分钟",
    views: 17650,
    likes: 1032,
    tags: ["选课", "学分规划", "校园攻略"],
    hot: false,
    featured: true,
    points: [
      "先把培养方案里的先修课画出来，再谈要不要抢热门课",
      "把容易冲突的课程分组，避免同一时段全押在一起",
      "留出至少一个学期的弹性，实习和考研才不会手忙脚乱",
    ],
    content: [
      { type: "p", text: "大一那年我选课全靠手速，看到评分高就抢，结果大二发现两门先修课撞在一起，整个学期都被打乱。后来我做了一张表，才算真正把四年理顺。" },
      { type: "h2", text: "第一步：把先修关系画成箭头" },
      { type: "p", text: "我从培养方案里把所有专业必修列出来，标上「谁是谁的前置」。画完之后一眼就能看出：哪些课必须早修，否则后面的课会全部卡住。这一步花了两个小时，省掉了后面无数次返工。" },
      { type: "h2", text: "第二步：给课程分组" },
      { type: "p", text: "我把课程分成四组：必须早修的、可以缓的、想选的兴趣课、以及用来凑学分的保底课。选课时先保证第一组，再填其他组。" },
      { type: "quote", text: "「不要为了抢一门热门课，堵死一整条先修链。」" },
      { type: "h2", text: "第三步：给未来留一段空白" },
      { type: "p", text: "大三下和大四通常会遇到实习、考研、毕业设计三件事。我在课表里刻意留了一到两个学期，几乎没有硬课，专门用来应对这些不确定。" },
      { type: "p", text: "这张表后来被我传给好几个学妹。她们反馈说，最大的收获不是少选错课，而是终于知道每学期该焦虑什么、不该焦虑什么。" },
    ],
  },
  {
    id: "cam-002",
    title: "社团换届前夜，我们复盘了让新生留下来的三个细节",
    summary:
      "招新时几百人报名，学期末只剩十几个。问题通常不在活动不够精彩，而在三个容易被忽略的日常细节。",
    category: "campus",
    categoryName: "校园瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20club%20banner%20and%20name%20badges%20shapes%2C%20olive%20and%20cream%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-08&orientation=landscape",
    author: "社团老李",
    authorRole: "前任社长",
    date: "2026-09-07",
    readTime: "5 分钟",
    views: 12340,
    likes: 690,
    tags: ["社团", "招新", "团队运营"],
    hot: false,
    featured: false,
    points: [
      "新人第一次任务要「低门槛、有反馈」，而不是直接扔大活",
      "群里要有稳定的日常互动，而不是只在活动前刷屏",
      "让每个新人都有一个具体的人对接，而不是面对整个组织",
    ],
    content: [
      { type: "p", text: "我们社团招新时报名了两百多人，第一次活动来了八十个。到学期末，还愿意留下来的不到二十个。换届前夜，我们几个老成员坐下来认真复盘。" },
      { type: "h2", text: "细节一：第一次任务的门槛" },
      { type: "p", text: "新人退出，很多时候不是因为不感兴趣，而是第一次被安排的任务太大、太模糊，做完也不知道好不好。后来我们改成给新人安排「一小时内能完成、当天能收到反馈」的小任务，留存明显变好。" },
      { type: "h2", text: "细节二：群里的日常感" },
      { type: "p", text: "如果群里只在活动前才刷屏，新人会觉得这是一个「用完就走」的工具群。我们开始鼓励日常分享，哪怕是一只猫的照片，也让群显得有人气。" },
      { type: "quote", text: "「人不愿意留在一个只在大事发生时才有声音的组织里。」" },
      { type: "h2", text: "细节三：给新人一个具体的人" },
      { type: "p", text: "面对一整个组织，新人会犹豫要不要提问。我们把每个新人都分给一位老成员对接，让「有事找谁」变得明确。这个改变几乎不花成本，却是我们复盘里最有效的一条。" },
    ],
  },
  {
    id: "cam-003",
    title: "宿舍矛盾多半不是人品问题，是作息和边界没谈清",
    summary:
      "住在一起的人，摩擦往往来自没说出口的期待。开学前把三件事谈明白，能省掉一学期的内耗。",
    category: "campus",
    categoryName: "校园瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20dorm%20room%20with%20beds%20lamps%20and%20desk%20shapes%2C%20golden%20amber%20and%20cream%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-09&orientation=landscape",
    author: "住过六人间的小周",
    authorRole: "毕业生",
    date: "2026-09-06",
    readTime: "5 分钟",
    views: 16480,
    likes: 987,
    tags: ["宿舍", "人际关系", "边界感"],
    hot: true,
    featured: false,
    points: [
      "把作息时间摆在明面上，比互相忍耐更有效",
      "提前聊清借东西的边界，避免小事积累成心结",
      "冲突发生时先谈具体行为，不要给人格贴标签",
    ],
    content: [
      { type: "p", text: "我住过六人间，也见过身边因为宿舍关系闹得很难受的朋友。回头看，绝大多数矛盾都不是谁坏，而是大家带着不同的默认规则住到了一起。" },
      { type: "h2", text: "要谈的第一件事：作息" },
      { type: "p", text: "有人十一点就睡，有人凌晨两点还在敲键盘。这本身没有对错，但如果不提前说，早睡的人会觉得被冒犯，晚睡的人会觉得被管束。开学第一周就把大致的作息亮出来，比后来的忍耐有效得多。" },
      { type: "h2", text: "要谈的第二件事：借用的边界" },
      { type: "p", text: "洗发水、充电线、零食，这些小事最容易积怨。与其事后抱怨，不如一开始就说清哪些可以随便用、哪些要先问一声。" },
      { type: "quote", text: "「说出来的规矩叫约定，没说的规矩叫委屈。」" },
      { type: "h2", text: "冲突时只谈行为" },
      { type: "p", text: "真的发生摩擦时，尽量说「昨晚一点你视频的声音我睡不着」，而不是「你太自私了」。前者能被解决，后者只会让人防御。" },
      { type: "p", text: "宿舍关系不需要成为好朋友，能互相尊重地住完这段日子，就已经是很好的结果。" },
    ],
  },
  {
    id: "loc-001",
    title: "老街那家开了二十年的面馆，为什么突然排起了长队",
    summary:
      "一家没什么变化的小馆子，最近中午要排队四十分钟。我们蹲了三天，发现走红的真正原因和味道关系不大。",
    category: "local",
    categoryName: "同城瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20noodle%20bar%20with%20steaming%20bowls%20and%20stools%20shapes%2C%20coral%20and%20olive%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-10&orientation=landscape",
    author: "同城小分队",
    authorRole: "街访记录",
    date: "2026-09-12",
    readTime: "6 分钟",
    views: 26900,
    likes: 1650,
    tags: ["同城探店", "老街", "城市观察"],
    hot: true,
    featured: true,
    points: [
      "走红不是因为改了配方，而是被一条同城帖子带火",
      "二十年的老客人变成了免费的推荐人",
      "店家没有扩张，反而用「限量」守住了口碑",
    ],
    content: [
      { type: "p", text: "这条老街这两年安静了很多，唯独中午十一点半，那家门脸不大的面馆门口会排起一条队。要知道，它已经在这里开了二十年，味道没变、价格也涨得很慢。" },
      { type: "h2", text: "转折点是一条谁都没在意的帖子" },
      { type: "p", text: "老板说，变化是从今年春天开始的。一位常客随手发了条同城帖子，讲他十年前在这里吃面的故事，配了张很普通的门脸照。那条帖子被转了几千次，第二天中午就来了很多第一次上门的年轻人。" },
      { type: "h2", text: "老客人成了最卖力的推荐人" },
      { type: "p", text: "我在排队的队伍里遇到一位从大学吃到现在的客人。他说自己至少带过二十个朋友来。「你以为我是来吃面的，其实是来找回忆的。」对很多老城区的人来说，这家店是他们的时间坐标。" },
      { type: "quote", text: "「网红店靠流量，老店靠的是有人愿意替你说话。」" },
      { type: "h2", text: "老板做了一个反直觉的决定" },
      { type: "p", text: "排队最长的时候，好几拨人劝老板开分店。他没同意，只在柜台贴了张纸：「每天限做三百碗，卖完就收。」他说，做得再多，味道就守不住了。" },
      { type: "p", text: "离开时我回头看了一眼那条队伍。排队的理由各不相同，但愿意等的人，大概都在等一碗不会让他们失望的面。" },
    ],
  },
  {
    id: "loc-002",
    title: "社区新增的夜间自习角，是怎么从一句抱怨变成常态的",
    summary:
      "一句「晚上没地方看书」的抱怨，最后变成了一间灯亮到十一点的社区自习角。这件事的推进过程，比结果更有意思。",
    category: "local",
    categoryName: "同城瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20community%20study%20corner%20with%20lamps%20and%20bookshelf%20shapes%2C%20amber%20and%20olive%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-11&orientation=landscape",
    author: "社区观察笔记",
    authorRole: "街坊",
    date: "2026-09-05",
    readTime: "5 分钟",
    views: 14200,
    likes: 812,
    tags: ["社区", "公共空间", "城市生活"],
    hot: false,
    featured: false,
    points: [
      "起点是居民群里一句很普通的抱怨，被人认真接住了",
      "真正的难点不是场地，而是谁来管、怎么管",
      "靠一份简单的值日表，让公共空间持续运转",
    ],
    content: [
      { type: "p", text: "「附近有没有晚上能看书的地方？」这句话在居民群里出现过不止一次，以前都没人接话。直到今年夏天，一位退休教师把这个问题认真往下推了一步。" },
      { type: "h2", text: "从一句抱怨到一次试运行" },
      { type: "p", text: "她先找到社区活动室，确认晚上七点后基本空置，然后拉了十几个有兴趣的邻居，约定先试运行两周。场地不用新盖，钥匙也不用新配，成本低到几乎没有理由拒绝。" },
      { type: "h2", text: "难题从来不是场地" },
      { type: "p", text: "试运行的第三天就遇到了问题：有人带饮料进来、有人忘记关灯。于是大家坐下来定了几条简单的规则，谁值日、几点清场、垃圾谁带下楼。" },
      { type: "quote", text: "「公共空间不是建好就有人用，是有人愿意每天多留五分钟才活得下去。」" },
      { type: "h2", text: "一张值日表撑起了一间自习角" },
      { type: "p", text: "现在墙上贴着一张手写的值日表，每周排一个人锁门。来的人形形色色：备考的年轻人、写论文的研究生、陪孩子写作业的家长。" },
      { type: "p", text: "这件事没有惊天动地的部分，但它说明了一个朴素的道理：一件小事能不能变成常态，往往取决于有没有人愿意把它接着做完。" },
    ],
  },
  {
    id: "ind-001",
    title: "同一批岗位需求变了：从「会工具」到「能负责一条线」",
    summary:
      "翻了几十份今年的招聘描述，我发现同样的岗位名称下，要求已经悄悄变了。这个变化对求职者和在职者都是提醒。",
    category: "industry",
    categoryName: "行业瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20job%20chart%20with%20connected%20nodes%20and%20arrow%20shapes%2C%20deep%20olive%20and%20cream%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-12&orientation=landscape",
    author: "行业观察站",
    authorRole: "招聘侧记录",
    date: "2026-09-11",
    readTime: "7 分钟",
    views: 20110,
    likes: 1288,
    tags: ["行业变化", "招聘", "职业发展"],
    hot: false,
    featured: true,
    points: [
      "同样的岗位名称，今年的描述更强调「独立负责」",
      "工具熟练度正在变成基础项，而不是加分项",
      "能讲清「我负责的那条线带来了什么」的人更受青睐",
    ],
    content: [
      { type: "p", text: "为了给一个朋友做求职参考，我翻了几十份今年发布的岗位描述。有意思的是，很多岗位的名字和两年前一样，但里面的要求已经换了重心。" },
      { type: "h2", text: "变化一：从「会」到「负责」" },
      { type: "p", text: "以前很多描述会写「熟练使用某工具」「有相关经验优先」。今年更常见的是「能独立负责一条业务线」「对结果负责」。工具熟练度不再是亮点，而是入场券。" },
      { type: "h2", text: "变化二：对「讲清楚」的要求变高了" },
      { type: "p", text: "越来越多的岗位强调沟通与协作。原因也不难理解：当分工变细、节奏变快，一个人能不能把复杂的事说明白，直接决定团队效率。" },
      { type: "quote", text: "「会做的人很多，能说明白自己为什么这么做的人很少。」" },
      { type: "h2", text: "对在职者的提醒" },
      { type: "p", text: "如果你现在的工作只是「按要求完成任务」，可以试着往前一步：主动去了解任务背后的目标、参与决定怎么做，并记录你带来的变化。这些积累，在下一次机会来临时就是你的底气。" },
      { type: "p", text: "行业的变化不会同时发生在所有人身上，但它一定会先发生在招聘描述里。多看一眼这些文字，比刷十条行业八卦更有用。" },
    ],
  },
  {
    id: "ind-002",
    title: "小团队做产品，为什么先砍功能反而是对的",
    summary:
      "功能越加越多，产品反而越没人用。小团队资源有限，砍掉一半功能，往往才是活下来的关键。",
    category: "industry",
    categoryName: "行业瓜",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20product%20blocks%20being%20removed%20from%20a%20stack%2C%20coral%20and%20olive%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=1200&height=750&seq=art-511-13&orientation=landscape",
    author: "产品老周",
    authorRole: "创业团队",
    date: "2026-09-09",
    readTime: "6 分钟",
    views: 15730,
    likes: 964,
    tags: ["产品", "创业", "取舍"],
    hot: false,
    featured: false,
    points: [
      "功能数量不等于价值，未被使用的能力就是成本",
      "小团队真正的优势是能快速砍掉做错的东西",
      "先做透一个高频场景，比铺满菜单更容易被记住",
    ],
    content: [
      { type: "p", text: "我们团队做第一个产品时，最兴奋的事就是「加功能」。半年后回头看，真正被用户高频使用的，只有其中两个。" },
      { type: "h2", text: "每一个功能都有隐形成本" },
      { type: "p", text: "加一个功能，不只是多写一段代码，还意味着要多一个入口、多一份文档、多一种需要维护的边界情况。用户看不懂的菜单，本质上是在增加他的认知负担。" },
      { type: "h2", text: "砍功能才是小团队的护城河" },
      { type: "p", text: "大团队资源多，可以同时试很多方向。小团队的优势恰恰相反：决策链短，能迅速承认某个方向不对并砍掉。把有限的精力压到一件事上，才可能做出别人做不到的深度。" },
      { type: "quote", text: "「用户不会因为你功能多而留下，只会因为你某件事做得足够好而记住你。」" },
      { type: "h2", text: "怎么判断该砍哪个" },
      { type: "p", text: "我们的标准很简单：过去一个月有多少人主动用过？如果答案是「几乎没有人」，那它就该进观察名单。砍掉之后，团队反而更清楚下一步该往哪走。" },
      { type: "p", text: "做减法比做加法难得多，因为它逼你面对一个残酷的问题：你到底想为谁解决什么。能答清楚这个问题，产品才刚开始成形。" },
    ],
  },
];